import React from 'react';

// Hexagon-radar glyph for the player profile "Attributes" tab.
// Stroke-based like the sibling tab icons (StatisticsIcon, MarketValue, ...).
const AttributesIcon = ({ color = "currentColor" }) => {
    return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon points="12,2.75 20.25,7.5 20.25,16.5 12,21.25 3.75,16.5 3.75,7.5" stroke={color} strokeWidth="1.5" strokeLinejoin="round"/>
            <polygon points="12,7.5 16.5,10.5 15,15.5 9.5,15 8.25,10" stroke={color} strokeWidth="1.2" strokeLinejoin="round"/>
            <line x1="12" y1="2.75" x2="12" y2="7.5" stroke={color} strokeWidth="1" strokeLinecap="round"/>
            <line x1="20.25" y1="7.5" x2="16.5" y2="10.5" stroke={color} strokeWidth="1" strokeLinecap="round"/>
            <line x1="20.25" y1="16.5" x2="15" y2="15.5" stroke={color} strokeWidth="1" strokeLinecap="round"/>
            <line x1="12" y1="21.25" x2="9.5" y2="15" stroke={color} strokeWidth="1" strokeLinecap="round"/>
            <line x1="3.75" y1="16.5" x2="9.5" y2="15" stroke={color} strokeWidth="1" strokeLinecap="round"/>
            <line x1="3.75" y1="7.5" x2="8.25" y2="10" stroke={color} strokeWidth="1" strokeLinecap="round"/>
        </svg>
    );
};

export default AttributesIcon;
